"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

const TokenSymbol = {
  _enum: {
    ASG: 0,
    BNC: 1,
    KUSD: 2,
    DOT: 3,
    KSM: 4,
    ETH: 5,
    KAR: 6,
    ZLK: 7
  }
};
const xcmV0 = {
  MultiAsset: 'MultiAssetV0',
  Xcm: 'XcmV0',
  XcmOrder: 'XcmOrderV0',
  MultiLocation: 'MultiLocationV0',
  XcmError: 'XcmErrorV0',
  Response: 'ResponseV0'
};
const xcmV1 = {
  MultiAsset: 'MultiAssetV1',
  Xcm: 'XcmV1',
  XcmOrder: 'XcmOrderV1',
  MultiLocation: 'MultiLocationV1',
  XcmError: 'XcmErrorV1',
  Response: 'ResponseV1'
};
const versioned = [{
  minmax: [0, 901],
  types: _objectSpread({
    TokenSymbol
  }, xcmV0)
}, {
  minmax: [902, undefined],
  types: _objectSpread({}, xcmV1)
}];
var _default = versioned;
exports.default = _default;